const ListingViewStatistics = ({
  similarFloorplans = {
    stats: {
      startDate: '',
      endDate: '',
      views: {
        total: 0,
      },
      inquiries: {
        total: 0,
      },
    },
  },
  stats = {
    startDate: '',
    endDate: '',
    views: {
      total: 0,
    },
    inquiries: {
      total: 0,
    },
  },
}) => ({
  similarFloorplans: Object(similarFloorplans),
  stats: Object(stats),
});

export default ListingViewStatistics;

export type ListingViewStatisticsProps = ReturnType<typeof ListingViewStatistics>;
